export default __webpack_public_path__ + "static/media/A_human_other.a67e6bd0.png";